import { Component, OnDestroy, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { TokenTimerService } from 'src/app/core/token/token-timer.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-aviso-token-expirando',
  templateUrl: './aviso-token-expirando.component.html',
  styleUrls: ['./aviso-token-expirando.component.scss']
})
export class AvisoTokenExpirandoComponent implements OnInit, OnDestroy {
  public tempoExpirar: number | null = null;

  private subscriptions = new Subscription();

  constructor(
    private tokenTimerService: TokenTimerService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.subscriptions.add(
      this.tokenTimerService.tempoExpirar$.subscribe((tempoExpirar) => {
        this.tempoExpirar = tempoExpirar;
      })
    );

    this.tokenTimerService.start();
  }

  onRenewToken(): void {
    this.subscriptions.add(
      this.tokenTimerService.renovaToken().subscribe({
        next: () => {
          this.toastr.show(
            this.translate.instant('ATUALIZADO_SUCESSO'),
            '',
            environment.toastrConfig('success')
          );
        },
        error: (error) => {
          console.error(error);
          this.toastr.show(
            this.translate.instant('ERRO_RENOVAR_TOKEN'),
            '',
            environment.toastrConfig('warning')
          );
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
